import React from 'react';
import { IconProps } from '.';

const SvgColoredFlag = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#606567' d='M9 21.765S9 23 7.5 23 6 21.765 6 21.765V3.235S6 2 7.5 2 9 3.235 9 3.235v18.53Z' />
      <path
        fill='#F05046'
        d='M6 2.573a1 1 0 0 1 1.424-.905l12.644 5.927a1 1 0 0 1 0 1.81L7.424 15.332A1 1 0 0 1 6 14.427V2.573Z'
      />
    </svg>
  );
};

export default SvgColoredFlag;
